import React__default from 'react';
import { EGDSPillContainer } from '@egds/react-core/pill';
import { classNames } from '@egds/react-core/utils';
import { EGDSIcon } from '@egds/react-core/icons';
import styles from '../styles/egds-search-experience-single-select-pill-wrapper.css';

const getClassNameList = classNames.bind(styles);
const SingleSelectPill = ({ active, altText, checked = false, className, disabled, icon, id, name, onChange, selected, text, value }) => {
    // To rename this, you have to rename baseClassName in UitkPillContainer as well
    const baseClassName = 'single-select-pill';
    const wrapperClassName = getClassNameList(baseClassName, className, {
        [`${baseClassName}-disabled`]: disabled,
    });
    const pillContentClassName = getClassNameList(`${baseClassName}-content`, {
        [`${baseClassName}-active`]: active,
        [`${baseClassName}-selected`]: selected,
    });
    const inputValue = value ?? `${checked}`;
    return (React__default.createElement("div", { className: wrapperClassName },
        React__default.createElement("input", { id: id, name: name, checked: checked, "aria-checked": checked, type: "radio", onChange: onChange, className: getClassNameList(`${baseClassName}-standard is-visually-hidden`), disabled: disabled, value: inputValue }),
        React__default.createElement("label", { className: pillContentClassName, htmlFor: id, "aria-label": altText },
            icon && React__default.createElement(EGDSIcon, { className: getClassNameList(`${baseClassName}-icon`), name: icon }),
            React__default.createElement("span", { className: getClassNameList(`${baseClassName}-text`) }, text))));
};
SingleSelectPill.displayName = 'SingleSelectPill';

const SingleSelectPillWrapper = ({ data, handleSelectedPill, wrap = false, align, }) => {
    const handleChange = (event) => {
        const selectedPillValue = event.target.value;
        handleSelectedPill(selectedPillValue);
    };
    const getClassNameList = classNames.bind(styles);
    return (React__default.createElement(EGDSPillContainer, { className: getClassNameList('single-select-pill-wrapper'), wrap: wrap, align: align }, data.map(({ id, selected, ...rest }) => (React__default.createElement(SingleSelectPill, { id: id, key: id, ...rest, selected: selected, checked: selected, onChange: handleChange })))));
};
SingleSelectPillWrapper.displayName = 'SingleSelectPillWrapper';

export { SingleSelectPillWrapper as S, SingleSelectPill as a };
//# sourceMappingURL=index-chunk.esm.js.map
